import React from 'react';
import { LogOut,  Settings } from 'lucide-react';
import { useNavigate, NavLink } from 'react-router-dom'; // ✅ useNavigate imported
import { API_IMAGE_URL2 } from '../lib/api';

const Header = ({ user, onLogout }) => {
  const navigate = useNavigate(); // ✅ Get navigate function

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('employee');
    if (onLogout) onLogout();
    navigate('/login'); // ✅ Redirect properly
  };

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <img
              src="../../image/shubham-infotech.png"
              alt="Shubham Infotech Logo"
              className="w-full h-10 object-contain"
            />
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <NavLink to="/dashboard/profile" title="Profile">
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors">
              <Settings className="w-5 h-5" />
            </button>
          </NavLink>

          {user && (
            <div className="flex items-center space-x-3">
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">{user.full_name}</p>
                <p className="text-xs text-gray-500 capitalize">{user.department}</p>
              </div>
              <div className="w-8 h-8 bg-gray-300 rounded-full overflow-hidden">
                <img
                  src={user.profile_image ? `${API_IMAGE_URL2}${user.profile_image}` : '/default-avatar.png'}
                  alt="Profile"
                  className="w-8 h-8 object-cover rounded-full"
                />
              </div>
            </div>
          )}

          <button
            onClick={handleLogout}
            className="flex items-center space-x-2 px-3 py-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
          >
            <LogOut className="w-4 h-4" />
            <span className="text-sm">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
